import React from 'react';
import AnimateFootball from '@components/animate-football';

export default function Loading({ message }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="block mb-4 mt-[-300px]">
        {message && (
          <p className="text-xl font-semibold text-gray-700">{message}...</p>
        )}
      </div>
      <AnimateFootball height={50} />
    </div>
  );
}
